// // previousRoute.js

// export const previousRoute = {
//   state:{
//     previousRouteName: null
//   },
//   getters : {
//     previousRouteName: state => state.previousRouteName
//   },
//   mutations :{
//     setPreviousRouteName(state, data) {
//       state.previousRouteName = data;
//     }
//   },
//   actions: {
//     previousRouteName(store, data) {
//       store.commit('setPreviousRouteName', data);
//     }
//   }
// };


// previousRoute.js

export const previousRoute = {
  state:{
    previousRouteName: null
  },
  getters : {
    PREVIOUS_ROUTE_NAME: state => state.previousRouteName
  },
  mutations :{
    SET_PREVIOUS_ROUTE_NAME(state, data) {
      state.previousRouteName = data;
    }
  },
  actions: {
    PREVIOUS_ROUTE_NAME(store, data) {
      store.commit('SET_PREVIOUS_ROUTE_NAME', data);
    }
  }
};


